import classNames from 'classnames/bind'

import styles from './LogValue.module.scss'

import type {LogValueEntry, LogValueNode} from '../../type'
import type {FC, ReactNode} from 'react'

const cx = classNames.bind(styles)

interface EntryRowProps {
    entry: LogValueEntry
    depth: number
    renderValue: (node: LogValueNode, depth: number) => ReactNode
}

const EntryRow: FC<EntryRowProps> = ({entry, depth, renderValue}) => (
    <div className={cx('entry', {nonEnumerable: entry.nonEnumerable})}>
        <span className={cx('key')}>{entry.key}</span>
        <span className={cx('seperator')}>:&nbsp;</span>
        {renderValue(entry.value, depth)}
    </div>
)

export default EntryRow
